import styled from "styled-components"

export const ScienceContainer = styled.div`
  padding: 80px 0;
  background-image: url(${props => props.img});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: #def4ff;

  h1 {
    max-width: 800px;
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 40px;
  }

  .col-lg-6 {
    text-align: center;
    img {
      max-width: 500px;
      @media (max-width: 768px) {
        display: none;
      }
    }

    ul {
      li {
        margin: 12px 0;
        a {
          button {
            background-color: ${props => props.theme.colors.white};
            color: ${props => props.theme.colors.darkBlue};
            border: none;
            border-radius: 8px;
            padding: 16px;
            width: 100%;
            transition: 0.3s ease;
            font-weight: 400;
            &:hover {
              background-color: ${props => props.theme.colors.brightBlue};
              color: ${props => props.theme.colors.white};
            }
          }
        }
      }
    }
  }
`
export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`
